$(document).ready(function () {
	$('[data-toggle=prd-image]').click(function () {
		return false;
	});

	$('[data-toggle=prd-image]').hover(function () {
		let $container = $(this).closest('.vg-shop-product--images'),
			$thumbs = $(this).closest('.image-area--thumb'),
			$original = $container.find('.image-area--original'),
			src_big = $(this).data('original'),
			src_medium = $(this).attr('href'),
			key = $(this).data('key');

		$thumbs.find('.active').removeClass('active');
		$(this).addClass('active');
		
		$original.find('a').attr('href', src_medium).data('key', key);
		$original.find('img').attr('src', src_big);
		
		return false;
	});
	
	$('[data-toggle=prd-image-full]').click(function () {
		let $container = $('.vg-shop-product--images');
		let $thumbs = $container.find('.image-area--thumb').find('[data-original]');
		let thumbs = [];
		let key = $(this).data('key');
		
		if ($thumbs.length) {
			$.merge($thumbs.slice(key), $thumbs.slice(0, key)).each(function () {
				let $_self = $(this),
					src = $_self.attr('href');
				
				thumbs.push({
					src: src
				});
			});
		} else {
			thumbs.push({
				src: $(this).attr('href')
			});
		}
		
		$.fancybox.open(thumbs, {
			loop: true,
			buttons: [
				"zoom",
				//"share",
				"slideShow",
				"fullScreen",
				//"download",
				//"thumbs",
				"close"
			],
			
			thumbs: {
				autoStart: true
			},
			
			lang: "ru",
			i18n: {
				ru: {
					CLOSE: "Закрыть",
					NEXT: "Следующий",
					PREV: "Предыдущий",
					ERROR: "Запрашиваемый контент не удалось загрузить. <br/> Попробуйте позже.",
					PLAY_START: "Запустить слайдшоу",
					PLAY_STOP: "Остановить слайдшоу",
					FULL_SCREEN: "Навесь экран",
					THUMBS: "Миниатюры",
					DOWNLOAD: "Скачать",
					SHARE: "Поделиться",
					ZOOM: "Увеличить"
				}
			}
		});
		
		return false;
	});
});
